import { LoginSlice } from 'store/pages/login/slice'

export const LoginActions = {
  ...LoginSlice.actions,
}
